import DashboardLayout from 'src/pages/Dashboard/Layout/DashboardLayout.vue'
import AuthLayout from 'src/pages/Dashboard/Pages/AuthLayout.vue'
// GeneralViews
import NotFound from 'src/pages/GeneralViews/NotFoundPage.vue'

// Page Headers
import DefaultHeader from 'src/pages/Dashboard/DefaultHeader'
import DashboardHeader from 'src/pages/Dashboard/Dashboard/DashboardHeader.vue'

// Dashboard pages
import Dashboard from 'src/pages/Dashboard/Dashboard/Dashboard.vue' 
import Login from 'src/pages/Login.vue' 
import HistoricoFiscal from 'src/pages/Fiscal/HistoricoFiscal.vue' 
import FiscalCfe from 'src/pages/CFe/FiscalCfe.vue' 
import HistoricoEstoque from 'src/pages/Produtos/HistoricoEstoque.vue' 
import EntradaNota from 'src/pages/Fiscal/EntradaNota.vue' 
import Inventario from 'src/pages/Fiscal/Inventario.vue' 
import BuscaNota from 'src/pages/Fiscal/BuscaNota.vue' 

// Pages
import Caixa from  'src/pages/Relatorios/Caixa';
import Aniversario from  'src/pages/Dashboard/relatorios/Aniversario';  
import Telemetria from  'src/pages/Dashboard/relatorios/Telemetria';  
import VendasData from  'src/pages/Dashboard/relatorios/VendasData';
import VendasCFOP from  'src/pages/Dashboard/relatorios/VendasCFOP';
import VendasProdutos from 'src/pages/Dashboard/relatorios/VendasProdutos';
import VendasCategoria from 'src/pages/Dashboard/relatorios/VendasCategoria';
import VendasCategoriaFiscal from 'src/pages/Dashboard/relatorios/VendasCategoriaFiscal';
import VendasPagamentos from 'src/pages/Dashboard/relatorios/VendasPagamentos';
import Configuracoes from 'src/pages/Dashboard/configuracoes.vue';
import VendasHorarios from 'src/pages/Dashboard/relatorios/VendasHorarios';
import Lucro from 'src/pages/Dashboard/relatorios/Lucro';
import RelatorioGeral from 'src/pages/Dashboard/relatorios/RelatorioGeral';
import SelectStore from 'src/pages/SelectStore.vue';
import Monitor from 'src/pages/Monitor.vue';
import VendasVendedor from 'src/pages/Dashboard/relatorios/VendasVendedor';
import VendasApuracaoPISCOFINSVendasVendedor from 'src/pages/Dashboard/relatorios/VendasApuracaoPISCOFINS';
import TrocaMercadoria from 'src/pages/Dashboard/relatorios/TrocaMercadoria';


import Produtos from 'src/pages/Produtos.vue'
import FormaPagamentos from 'src/pages/Dashboard/cadastro/FormaPagamentos.vue'
import Fornecedores from 'src/pages/Dashboard/cadastro/Fornecedores.vue'
import CategoriaFiscal from 'src/pages/Dashboard/cadastro/CategoriaFiscal.vue'
import Categorias from 'src/pages/Dashboard/cadastro/Categorias.vue'
import Clientes from 'src/pages/Clientes.vue'

import CurrentIdi from 'src/middlewares/CurrentIdi.js'

import FinancesOverview from 'src/pages/Finances/FinancesOverview'
import FinancesPaymentMethod from 'src/pages/Finances/FinancesPaymentMethod'
import AccountPage from 'src/pages/Finances/AccountPage'
import CashFlow from 'src/pages/Finances/CashFlow'
import CategoryPage from 'src/pages/Finances/CategoryPage'

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/select',
    name: 'select',
    component: SelectStore
  },
  {
    path: '/',
    component: DashboardLayout,
    redirect: '/dashboard',
    name: 'DashboardLayout',
    meta: {
      middleware: CurrentIdi
    },
    children: [
      {
        path: '/monitor',
        name: 'monitor',
        components: {default: Monitor, header: DefaultHeader},
      },
      {
        path: 'dashboard',
        name: 'Dashboard',
        components: {default: Dashboard, header: DashboardHeader},
        meta: {
          middleware: CurrentIdi
        },
      },
      {
        path: 'configuracoes',
        name: 'Configuracoes',
        components: {default: Configuracoes, header: DefaultHeader},
        meta: {
          middleware: CurrentIdi
        },
      },
      {
        path: '/vendas',
        name: 'Relatórios - Vendas por data',
        components:  {default:VendasData, header: DefaultHeader},
        meta: {
          middleware: CurrentIdi
        },
      },
      {
        path: '/vendas_cfop',
        name: 'Relatórios - Vendas por data',
        components:  {default:VendasCFOP, header: DefaultHeader},
        meta: {
          middleware: CurrentIdi
        },
      },
      {
        path: '/relatorioGeral',
        name: 'Relatórios - Geral',
        components:  {default:RelatorioGeral, header: DefaultHeader},
        meta: {
          middleware: CurrentIdi
        },
      },
      {
        path: '/caixas',
        name: 'Relatórios - Caixas',
        components:  {default:Caixa, header: DefaultHeader},
        meta: {
          middleware: CurrentIdi
        },
      },
      {
        path: '/clientes/aniversariantes',
        name: 'Clientes - Aniversariantes',
        components:  {default:Aniversario, header: DefaultHeader},
      },
      {
        path: '/telemetria',
        name: 'Telemetria',
        components:  {default:Telemetria, header: DefaultHeader},
      },
      {
        path: '/lucro',
        name: 'Lucro',
        components:  {default:Lucro, header: DefaultHeader},
      },
      {
        path: '/vendasProdutos',
        name: 'Relatórios - Vendas Por Produtos',
        components:  {default:VendasProdutos, header: DefaultHeader},
        meta: {
          middleware: CurrentIdi
        },
        
      },
      {
        path: '/vendasCategorias',
        name: 'Relatórios - Vendas Por Produtos',
        components:  {default:VendasCategoria, header: DefaultHeader},
        meta: {
          middleware: CurrentIdi
        },
      },
      {
        path: '/vendasCategoriasFiscal',
        name: 'Relatórios - Vendas Por Produtos',
        components:  {default:VendasCategoriaFiscal, header: DefaultHeader},
        meta: {
          middleware: CurrentIdi
        },
      },
      {
        path: '/vendasPagamentos',
        name: 'Relatórios - Vendas por Forma de Pagamento',
        components:  {default:VendasPagamentos, header: DefaultHeader},
        meta: {
          middleware: CurrentIdi
        },
      },
      {
        path: '/vendasHorarios',
        name: 'Relatórios - Vendas por horário',
        components:  {default:VendasHorarios, header: DefaultHeader},
        meta: {
          middleware: CurrentIdi
        },
      },
      {
        path: '/vendedores',
        name: 'Relatórios - Vendas por vendedor',
        components:  {default:VendasVendedor, header: DefaultHeader},
      },
      {
        path: '/trocaMercadoria',
        name: 'Relatórios - Mercadorias Trocadas',
        components:  {default:TrocaMercadoria, header: DefaultHeader},
      },
      {
        path: '/fiscal',
        name: "FISCAL - vendas",
        components: {default: HistoricoFiscal, header: DefaultHeader},
        meta: {
          middleware: CurrentIdi
        },
      },
      {
        path: '/cfe',
        name: "FISCAL - vendas",
        components: {default: FiscalCfe, header: DefaultHeader},
        meta: {
          middleware: CurrentIdi
        },
      },
      {
        path: '/historico-estoque',
        name: "Produtos - Histórico",
        components: {default: HistoricoEstoque, header: DefaultHeader},
        meta: {
          middleware: CurrentIdi
        },
      },
      {
        path: '/relatorio-pis',
        name: "FISCAL - PIS COFINS",
        components: {default: VendasApuracaoPISCOFINSVendasVendedor, header: DefaultHeader},
        meta: {
          middleware: CurrentIdi
        },
      },
      {
        path: '/notasCompra',
        name: "FISCAL - compras",
        components: {default: EntradaNota, header: DefaultHeader},
        meta: {
          middleware: CurrentIdi
        },
      },
      {
        path: '/inventario',
        name: "FISCAL - inventário",
        components: {default: Inventario, header: DefaultHeader},
        meta: {
          middleware: CurrentIdi
        },
      },
      {
        path: '/notasCompraRobo',
        name: "FISCAL - compras",
        components: {default: BuscaNota, header: DefaultHeader},
        meta: {
          middleware: CurrentIdi
        },
      },
      {
        path: '/produtos',
        name: "Cadastros - Produtos",
        components: {default: Produtos, header: DefaultHeader},
        meta: {
          middleware: CurrentIdi
        },
      },
      {
        path: '/categorias',
        name: "Cadastros - Categorias",
        components: {default: Categorias, header: DefaultHeader},
        meta: {
          middleware: CurrentIdi
        },
      },
      {
        path: '/formaPagamento',
        name: "Cadastros - Forma Pagamento",
        components: {default: FormaPagamentos, header: DefaultHeader},
        meta: {
          middleware: CurrentIdi  
        },
      },
      {
        path: '/fornecedores',
        name: "Cadastros - Fornecedores",
        components: {default: Fornecedores, header: DefaultHeader},
        meta: {
          middleware: CurrentIdi  
        },
      },
      {
        path: '/categoriaFiscal',
        name: "Cadastros - Categoria Fiscal",
        components: {default: CategoriaFiscal, header: DefaultHeader},
        meta: {
          middleware: CurrentIdi  
        },
      },
      {
        path: '/clientes',
        name: "Cadastros - Clientes",
        components: {default: Clientes, header: DefaultHeader},
        meta: {
          middleware: CurrentIdi
        },
      },
      {
        path: '/financeiro/extrato',
        name: "Financeiro - Dashboard",
        components: {default: FinancesOverview, header: DefaultHeader},
        meta: {
          middleware: CurrentIdi
        }
      },
      {
        path: '/financeiro/formas-pagamento',
        name: "Financeiro - Formas Pagamento",
        components: {default: FinancesPaymentMethod, header: DefaultHeader},
        meta: {
          middleware: CurrentIdi
        }
      },
      {
        path: '/financeiro/contas',
        name: "Financeiro - Contas Bancárias",
        components: {default: AccountPage, header: DefaultHeader},
        meta: {
          middleware: CurrentIdi
        }
      },
      {
        path: '/financeiro/fluxo',
        name: "Financeiro - Fluxo",
        components: {default: CashFlow, header: DefaultHeader},
        meta: {
          middleware: CurrentIdi
        },
      },
      {
        path: '/financeiro/categorias/',
        name: "Financeiro - Categorias",
        components: {default: CategoryPage, header: DefaultHeader},
        meta: {
          middleware: CurrentIdi
        },
      },
    ]
  },
  {path: '*', component: NotFound}
];

export default routes
